import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';

const PublicRoute = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (isAuthenticated && user) {
    // Redirect based on user type - profile completion will be handled by GlobalRouteGuard
    switch (user.accountType) {
      case "organization": {
        if (user.metaData?.subscription?.isActive && new Date(user.metaData.subscription.endDate) > new Date()) {
          return <Navigate to="/organization/dashboard" replace />;
        } else {
          return <Navigate to="/organization/subscription/packages" replace />;
        }
      }
      case "supervisor":
        return <Navigate to="/organization/dashboard" replace />;
      case "player":
        return <Navigate to="/feed" replace />;
      case "talent-scout":
        return <Navigate to="/feed" replace />;
      default:
        return <Navigate to="/feed" replace />;
    }
  }

  return children;
};

export default PublicRoute; 